<template>
	<div class="drawer">
		<!-- :with-header="false" -->
		<el-drawer
		size="33%"
		title="查询条码"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<el-row style="padding:0px 20px 0;float: none;font-size: 20px;">
				<el-col>
					<el-form :inline="true"  @submit.native.prevent>
						<el-form-item >
							<label style="font-size: 12px;" slot="label" >录入条码</label>
							<el-input style="width:280px;" v-model="scanningCode" @keyup.enter.native="searchScanningCode" placeholder="请录入条码" size="small"></el-input>
						</el-form-item>
					</el-form>
				</el-col>
			</el-row>
			<el-row>
				<el-col>
					<div class="tableTit">条码信息</div>
				</el-col>
			</el-row>
	
			<el-form :inline="true" class="form">
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="名称:" :label-width="formLabelWidth">
								<span class="value">{{msg.goodsName}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="条码:" :label-width="formLabelWidth">
								<span class="value">{{msg.barcode}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="价格:" :label-width="formLabelWidth">
								<div class="value" v-for="(item,index) in msg.saleWays" :key="index">
									<div>标准价:{{item.pprice}}/{{item.packing_way_name}}                会员价:{{item.mprice}}/{{item.packing_way_name}}</div>
								
								</div>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="品牌:" :label-width="formLabelWidth">
								<span class="value">{{msg.brand}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row" v-if="msg.category_list">
					<el-col :span="24">
							<el-form-item label="类型:" :label-width="formLabelWidth">
								<span class="value">{{msg.category_list[0].name}}</span>
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="规格:" :label-width="formLabelWidth">
								<span class="value">{{msg.skuValue}}</span>
							
							</el-form-item>
					</el-col>
				</el-row>
				<el-row class="row">
					<el-col :span="24">
							<el-form-item label="所在门店:" :label-width="formLabelWidth">
								<span class="value" v-if="msg.currentShopId">{{$public.getShopNameById(msg.currentShopId)}}</span>
							</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'100px',
				scanningCode:'',
				msg:{},
				
				isGiftCard:false,
				giftCardMsg:{},
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('close')
			},
			searchScanningCode(){
				this.getGoodsMsg(this.scanningCode);
			},
			// 获取商品信息
			getGoodsMsg(code) {
				this.scanningCode=''
				code = (code).toString().trim();
				if(code){
					this.$http.get(process.env.VUE_APP_Url_baseData + '/api/product/goods/from/code', {
						barcode: code
					}).then(res=>{
						if(res.code==0){
							this.msg = res.data;
						}
					})
				}
				
			}
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				&.el-form--inline .el-form-item{
					margin:5px 0;margin-bottom:0;
					
				}
			}
		}
		.row{
			border-bottom:1px solid #F2F2F2;
			::v-deep .el-form-item__label{
				font-size: 12px;color:#999;
			}
			.value{
				font-size: 14px;color:#333;font-weight: bold;
			}
		}
		.tableTit{
			background-color: #FFF8F2;line-height: 44px;padding:0 20px;font-size: 14px;color:$fontColor;
		}
	}
	
</style>
